<template>
  <div>
    <PageMain ref="main" :data="data" :disabled="disabled" @remove="remove">
      <template #toolbar>
        <div class="py-2 d-flex align-items-center">
          <div class="side-frame">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_inspectionIssues') || '不良原因' }}
            </span>
          </div>

          <el-divider v-if="!disabled" direction="vertical" class="mx-3" />

          <el-button
            v-if="!disabled"
            type="danger"
            size="small"
            @click="notPassOpts.visible = true"
          >
            {{ $l('btn_add_issues') || '不良+1' }}
          </el-button>
        </div>
      </template>
    </PageMain>

    <InspectionIssuesNotPass
      :visible.sync="notPassOpts.visible"
      @confirm="notPass"
    />
  </div>
</template>
<script>
import lodash from 'lodash'
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main'
import InspectionIssuesNotPass from '../inspection-issues-not-pass'
export default {
  components: { PageMain, InspectionIssuesNotPass },
  mixins: [EditLoading],
  props: {
    data: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { notPassOpts: { visible: false } }
  },
  mounted() {},
  methods: {
    async remove({ issuesTitle } = {}) {
      if (!issuesTitle) return

      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const list = lodash.cloneDeep(this.data)

      const index = lodash.findIndex(list, { issuesTitle })
      if (index < 0) return

      list.splice(index, 1)

      this.$emit('update:data', list)
      this.$emit('change', list)
    },
    notPass(items) {
      if (!items?.length) return

      const issuesTitle = lodash.join(items, '、')

      const list = lodash.cloneDeep(this.data)

      const index = lodash.findIndex(list, { issuesTitle })
      if (index >= 0) {
        list[index].quantity += 1
      } else {
        const row = { issuesTitle, quantity: 1 }
        list.push(row)
      }

      this.$emit('update:data', list)
      this.$emit('change', list)
    },
  },
}
</script>

<style lang="scss" scoped>
.side-frame {
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 10px;
  padding-right: 0;
  margin-top: 3px;
  margin-bottom: 3px;
  border-left: 3px solid $color-danger;
}
</style>
